// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__23fUf","search":"Settings_search__2a8qE","filter":"Settings_filter__ob4SE"};